import { Card, Input } from "antd";
import React, { useContext } from "react";
import { DynamicForm, DynamicFormUtilsDataContext } from "../../DynamicForm";
import NodeList from "../Flow/NodeList";
import styles from "../manager.module.css";
import NextNodeConditions from "./Conditions";

const Node = ({
  config,
  nodeData,
  onModuleParamChange,
  onNodeNameChange,
  onModuleOptionChange,
}) => {
  const dynamicFormUtilsDataContext = useContext(DynamicFormUtilsDataContext);

  const handleNodeNameChange = function (e) {
    onNodeNameChange(e.target.value);
  };

  const handleParamChange = function (parameters) {
    onModuleParamChange(parameters);
  };

  const handleModuleOptionsChange = function (option) {
    onModuleOptionChange(option);
  };

  return nodeData ? (
    <div>
      <div className={styles.header}>
        <Card
          className={styles.section}
          title={<span className={styles.section_title}>Node name</span>}
          bordered={false}
        >
          <Input
            type="text"
            value={nodeData.name}
            onChange={handleNodeNameChange}
            data-key="name"
          />
        </Card>
      </div>

      <div className={styles.body}>
        <Card
          className={styles.section}
          title={
            <span className={styles.section_title}>Options du modules</span>
          }
          bordered={false}
        >
          <DynamicForm
            formData={nodeData.module.options}
            onParameterChange={handleModuleOptionsChange}
            parametersModel={config.moduleOptionsFormTemplate}
            utilsData={dynamicFormUtilsDataContext}
            id={nodeData.id}
          />
        </Card>

        <Card
          className={styles.section}
          title={
            <span className={styles.section_title}>Paramètres du module</span>
          }
          bordered={false}
        >
          {(config?.modules || {})[nodeData.module.options.type] && (
            <DynamicForm
              formData={nodeData.module.parameters}
              onParameterChange={handleParamChange}
              parametersModel={
                config.modules[nodeData.module.options.type].parameters
              }
              utilsData={dynamicFormUtilsDataContext}
              id={nodeData.id}
            />
          )}
        </Card>

        <Card
          className={styles.section}
          title={
            <span className={styles.section_title}>
              Gestion de l'ordre des conditions
            </span>
          }
          bordered={false}
        >
          <div className={styles.next_node_conditions}>
            <NextNodeConditions id={nodeData.id} />
          </div>
        </Card>
      </div>
    </div>
  ) : (
    <div className={styles.node_list_container}>
      <Card
        className={styles.section}
        title={
          <span className={styles.section_title}>
            Choisir un noeud à configurer
          </span>
        }
      >
        <NodeList />
      </Card>
    </div>
  );
};

export default Node;
